module.exports = __webpack_public_path__ + "static/img/dr_alert1.0e3ac1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/dr_alert1.png
// module id = 1219
// module chunks = 0